import React from 'react';
import { IEyecatcherPanel } from './eyecatcherPanel.d';
import { MatchEyecatcherType } from '../../../Common/enums';
import PercentageMatchEyecatcher from '../percentageEyecatcher/percentageMatchEyecatcher';
import styles from './eyecatcherPanel.scss';

function EyecatcherPanel(props: IEyecatcherPanel) {
    const { percentagePoints, proFeatureNumber, contraFeatureNumber, totoalFeatureNumber } = props;

    return (
        <div className={styles.eyecatcher_panel}>
            <PercentageMatchEyecatcher
                displayFeatureNumber={proFeatureNumber}
                percentagePoints={0}
                totoalFeatureNumber={totoalFeatureNumber}
                eyecatcherType={MatchEyecatcherType.pro} />
            <PercentageMatchEyecatcher
                percentagePoints={percentagePoints}
                eyecatcherType={MatchEyecatcherType.percentage} />
            <PercentageMatchEyecatcher
                displayFeatureNumber={contraFeatureNumber}
                percentagePoints={0}
                totoalFeatureNumber={totoalFeatureNumber}
                eyecatcherType={MatchEyecatcherType.contra} />
        </div>);
}

export default EyecatcherPanel;
